export default {
  BatchId: 'filters.BatchId',
  Channel: 'filters.Channel',
  ContainsProduct: 'filters.ContainsProduct',
  DestinationCountry: 'filters.DestinationCountry',
  ExceptionStatusReason: 'filters.ExceptionStatusReason',
  ExcludePostCutOffProcessing: 'filters.ExcludePostCutOffProcessing',
  FulfillmentCenter: 'filters.FulfillmentCenter',
  FulfillmentCost: 'filters.FulfillmentCost',
  HasDimensions: 'filters.HasDimensions',
  HasTrackingNumber: 'filters.HasTrackingNumber',
  HasGiftNote: 'filters.HasGiftNote',
  ImportDate: 'filters.ImportDate',
  IsLabelPrinted: 'filters.IsLabelPrinted',
  IsPicked: 'filters.IsPicked',
  ItemQuantity: 'filters.ItemQuantity',
  OnHoldStatusReason: 'filters.OnHoldStatusReason',
  OrderStatus: 'filters.OrderStatus',
  ProcessedUsingBatch: 'filters.ProcessedUsingBatch',
  ReservedForBatch: 'filters.ReservedForBatch',
  ShipDate: 'filters.ShipDate',
  StoreOrderId: 'filters.StoreOrderId',
  PurchaseDate: 'filters.PurchaseDate',
  CompletedStatus: 'filters.CompletedStatus',
  PossibleValues: {
    Boolean: {
      Yes: 'filters.PossibleValues.Boolean.Yes',
      No: 'filters.PossibleValues.Boolean.No'
    }
  },
  Placeholders: {
    SelectFilterText: 'filters.Placeholders.SelectFilterText',
    SelectValueText: 'filters.Placeholders.SelectValueText'
  }
}
